// extracted by mini-css-extract-plugin
export default {"container":"ImageCardAdd_container__E9-Tq","item":"ImageCardAdd_item__XKzkL"};